/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/7/2022
 */

import EventType from "@shared/scheduler/EventType";
import {Type} from "@qwoach/class-transformer-wrapper";
import SendingReminderWrapper from "@shared/scheduler/reminders/SendingReminderWrapper";
import ScheduledSessionRef from "@shared/CoachingPackage/ScheduledSessionRef";
import BaseIdObject from "@shared/BaseIdObject.js";


export default class SessionPackageWrapper extends BaseIdObject {

	sessionTypeId: string = null
	sessionTypeTitle: string = null
	sessionsCount: number = 0 // setting 0 allows to perform sum without checking for value
	sessionPrice: number = null
	sessionDuration: number = null

	@Type(() => ScheduledSessionRef)
	scheduledSessionRefs: ScheduledSessionRef[] = []

	@Type(() => SendingReminderWrapper)
	sendingReminderWrapperArray: SendingReminderWrapper[] = []

	_sessionType: EventType = null


	constructor() {
		super();
	}

	asEventType(){
		let eventType = new EventType()

		eventType.id = this.sessionTypeId
		eventType.displayName = this.sessionTypeTitle
		eventType.count = this.sessionsCount
		eventType.price = this.sessionPrice
		eventType.duration = this.sessionDuration

		return eventType
	}

	canScheduleMoreSessions(){
		return this.getConfirmedSessionCount() < this.sessionsCount
	}

	getAllScheduledSessionCount(){
		return this.scheduledSessionRefs.length
	}

	getConfirmedSessionCount(){
		let confirmedSessionsArray = this.scheduledSessionRefs.filter(session => session.isSessionConfirmed())
		return confirmedSessionsArray.length
	}

	addScheduledSessionRef(scheduledSession){
		let ref = new ScheduledSessionRef()
		ref.syncFromSession(scheduledSession)


		this.scheduledSessionRefs.push(ref)
	}

	findSessionRefById(sessionId){
		let index = this.scheduledSessionRefs.findIndex(ref => ref.id === sessionId)
		if(index >= 0){
			return this.scheduledSessionRefs[index]
		}
	}

	getLatestSessionRefByTime(){
		let latestRef
		for(let scheduledSessionRefs of this.scheduledSessionRefs){
			if(!latestRef || scheduledSessionRefs.endTime() > latestRef.endTime()){
				latestRef = scheduledSessionRefs
			}
		}
		return latestRef
	}
}
